import { render, staticRenderFns } from "./TagsListCell.vue?vue&type=template&id=46c25954"
import script from "./TagsListCell.vue?vue&type=script&lang=js"
export * from "./TagsListCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports